let sideOptions = [
  {
    title: '账户信息',
    child: [
      { name: '基础信息', key: 'accountInfos', toRouter: '/account/infos' }
    ]
  },
  {
    title: '开放许可管理',
    child: [{
        name: '开放许可信息',
        key: 'licenceInfos',
        toRouter: '/licence/infos'
      },
      {
        name: '发布开放许可',
        key: 'licenceIssue',
        toRouter: '/licence/issue'
      }
    ]
  },
  {
    title: '运营管理',
    child: [
      { name: '运营信息', key: 'operationInfos', toRouter: '/operation/infos' },
      {
        name: '发布运营信息',
        key: 'operationIssue',
        toRouter: '/operation/issue'
      }
    ]
  },
  {
    title: '需求管理',
    child: [
      { name: '需求信息', key: 'demandInfos', toRouter: '/demand/info' },
      { name: '发布需求', key: 'demandIssue', toRouter: '/demand/issue' }
    ]
  },
  // {
  //   title: '人才管理',
  //   child: [
  //     { name: '技术团队管理', key: 'techTeam', toRouter: '/talents/techTeam' },
  //     { name: '人才管理信息', key: 'talentsInfos', toRouter: '/talents/infos' }
  //   ]
  // },
  {
    title: '服务机构',
    child: [
      // { name: '金融服务管理', key: 'serverInfos', toRouter: '/server/finance' },
      { name: '服务机构管理', key: 'infosManage', toRouter: '/server/infos' }
    ]
  },
  // {
  //   title: '竞争对手库管理',
  //   child: [
  //     { name: '企业监控信息', key: 'superviseInfos', toRouter: '/supervise/infos' }
  //   ]
  // },
  {
    title: '信息管理',
    child: [
      {
        name: '综合信息管理',
        key: 'informationInfos',
        toRouter: '/information/infos'
      },
      {
        name: '产业信息服务管理',
        key: 'informationAnnounce',
        toRouter: '/information/announcement'
      }
      // {
      //   name: '创新主体管理',
      //   key: 'innovationSubject',
      //   toRouter: '/information/InnovationSubject',
      // },
    ]
  },
  {
    title: '内容审核',
    child: [
      { name: '需求审核', key: 'contentDemand', toRouter: '/content/demand' },
      {
        name: '运营信息审核',
        key: 'contentOperation',
        toRouter: '/content/operation'
      },
      {
        name: '服务信息审核',
        key: 'contentServer',
        toRouter: '/content/server'
      },
      {
        name: '开放许可信息审核',
        key: 'contentLicence',
        toRouter: '/content/licence'
      }
    ]
  },

  {
    title: '收藏管理',
    child: [{ name: '我的收藏', key: 'favoriteMy', toRouter: '/favorite/my' }]
  },
  {
    title: '系统管理',
    child: [
      { name: '用户管理', key: 'systemUser', toRouter: '/system/user' },
      {
        name: '用户统计',
        key: 'userStatistics',
        toRouter: '/system/userStatistics'
      },
      {
        name: '信息发布统计',
        key: 'messageStatistic',
        toRouter: '/system/messageStatistic'
      }
      // { name: '日志管理', key: 'systemLog', toRouter: '/system/log' }
    ]
  }
]
const nameMap = {
  accountInfos: '账户信息',
  demandInfos: '需求管理',
  demandIssue: '需求管理',
  operationInfos: '运营管理',
  operationIssue: '运营管理',
  serverInfos: '服务机构',
  infosManage: '服务机构',
  superviseInfos: '竞争对手库管理',
  informationInfos: '信息管理',
  informationAnnounce: '信息管理',
  innovationSubject: '信息管理',
  contentDemand: '内容审核',
  contentOperation: '内容审核',
  contentServer: '内容审核',
  talentsInfos: '人才管理',
  favoriteMy: '收藏管理',
  systemUser: '系统管理',
  systemLog: '系统管理',
  userStatistics: '系统管理',
  messageStatistic: '系统管理',
  techTeam: '人才管理',
  contentLicence:'内容审核',
  licenceInfos:'开放许可管理',
  licenceIssue:'开放许可管理'
}
let key = process.env.VUE_APP_KEY
if (key === 'Mz') {
  // 梅州
  const obj = {
    title: '人才管理',
    child: [
      { name: '技术团队管理', key: 'techTeam', toRouter: '/talents/techTeam' },
      { name: '人才管理信息', key: 'talentsInfos', toRouter: '/talents/infos' }
    ]
  }
  sideOptions.splice(3, 0, obj)
}
if(key === 'SzTech') {
  sideOptions.forEach(i => {
    if(i.child) {
      i.child = i.child.filter(j => j.name !== '产业信息服务管理')
    }
  })
}
module.exports = {
  sideOptions,
  // 映射表
  nameMap
}
